import _classCallCheck from "/Users/thomas/DEV/rwc/tcw-platzbelegung-r2wc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/thomas/DEV/rwc/tcw-platzbelegung-r2wc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/thomas/DEV/rwc/tcw-platzbelegung-r2wc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/thomas/DEV/rwc/tcw-platzbelegung-r2wc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/thomas/DEV/rwc/tcw-platzbelegung-r2wc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/Users/thomas/DEV/rwc/tcw-platzbelegung-r2wc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _wrapNativeSuper from "/Users/thomas/DEV/rwc/tcw-platzbelegung-r2wc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var j = Object.defineProperty;
var x = function x(t, e, r) {
  return e in t ? j(t, e, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: r
  }) : t[e] = r;
};
var b = function b(t, e, r) {
  return x(t, typeof e != "symbol" ? e + "" : e, r), r;
};
var C = {
    stringify: function stringify(t) {
      return t;
    },
    parse: function parse(t) {
      return t;
    }
  },
  T = {
    stringify: function stringify(t) {
      return "".concat(t);
    },
    parse: function parse(t) {
      return parseFloat(t);
    }
  },
  V = {
    stringify: function stringify(t) {
      return t ? "true" : "false";
    },
    parse: function parse(t) {
      return /^[ty1-9]/i.test(t);
    }
  },
  N = {
    stringify: function stringify(t) {
      return t.name;
    },
    parse: function parse(t, e) {
      var r = function () {
        if (typeof window < "u" && t in window) return window[t];
        if (typeof global < "u" && t in global) return global[t];
      }();
      return typeof r == "function" ? r.bind(e) : void 0;
    }
  },
  P = {
    stringify: function stringify(t) {
      return JSON.stringify(t);
    },
    parse: function parse(t) {
      return JSON.parse(t);
    }
  },
  w = {
    string: C,
    number: T,
    boolean: V,
    function: N,
    json: P
  },
  A = Symbol.for("r2wc.render"),
  h = Symbol.for("r2wc.connected"),
  u = Symbol.for("r2wc.context"),
  i = Symbol.for("r2wc.props");
function z(t, e, r) {
  var $, k, O;
  e.props || (e.props = t.propTypes ? Object.keys(t.propTypes) : []);
  var d = (Array.isArray(e.props) ? e.props.slice() : Object.keys(e.props)).filter(function (s) {
      return s !== "container";
    }),
    f = {},
    g = {},
    m = {};
  var _iterator = _createForOfIteratorHelper(d),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var s = _step.value;
      f[s] = Array.isArray(e.props) ? "string" : e.props[s];
      var p = J(s);
      g[s] = p, m[p] = s;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  var S = /*#__PURE__*/function (_HTMLElement) {
    _inherits(S, _HTMLElement);
    function S() {
      var _this;
      _classCallCheck(this, S);
      _this = _possibleConstructorReturn(this, _getPrototypeOf(S).call(this));
      b(_assertThisInitialized(_assertThisInitialized(_this)), $, !0);
      b(_assertThisInitialized(_assertThisInitialized(_this)), k);
      b(_assertThisInitialized(_assertThisInitialized(_this)), O, {});
      b(_assertThisInitialized(_assertThisInitialized(_this)), "container");
      e.shadow ? _this.container = _this.attachShadow({
        mode: e.shadow
      }) : _this.container = _assertThisInitialized(_assertThisInitialized(_this)), _this[i].container = _this.container;
      var _iterator2 = _createForOfIteratorHelper(d),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var c = _step2.value;
          var l = g[c],
            n = _this.getAttribute(l),
            o = f[c],
            a = w[o];
          n && a != null && a.parse && (_this[i][c] = a.parse(n, _assertThisInitialized(_assertThisInitialized(_this))));
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      return _this;
    }
    _createClass(S, [{
      key: "connectedCallback",
      value: function connectedCallback() {
        this[h] = !0, this[A]();
      }
    }, {
      key: "disconnectedCallback",
      value: function disconnectedCallback() {
        this[h] = !1, this[u] && r.unmount(this[u]);
      }
    }, {
      key: "attributeChangedCallback",
      value: function attributeChangedCallback(c, l, n) {
        var o = m[c],
          a = f[o],
          y = w[a];
        o in f && y != null && y.parse && (this[i][o] = y.parse(n, this), this[A]());
      }
    }, {
      key: ($ = h, k = u, O = i, A),
      value: function value() {
        this[h] && (this[u] ? r.update(this[u], this[i]) : this[u] = r.mount(this.container, t, this[i]));
      }
    }], [{
      key: "observedAttributes",
      get: function get() {
        return Object.keys(m);
      }
    }]);
    return S;
  }(_wrapNativeSuper(HTMLElement));
  var _iterator3 = _createForOfIteratorHelper(d),
    _step3;
  try {
    var _loop = function _loop() {
      var s = _step3.value;
      var p = g[s],
        c = f[s];
      Object.defineProperty(S.prototype, s, {
        enumerable: !0,
        configurable: !0,
        get: function get() {
          return this[i][s];
        },
        set: function set(l) {
          this[i][s] = l;
          var n = w[c];
          if (n != null && n.stringify) {
            var o = n.stringify(l);
            this.getAttribute(p) !== o && this.setAttribute(p, o);
          }
        }
      });
    };
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      _loop();
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }
  return S;
}
function J() {
  var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  return t.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
}
export { z as default };